import type { Conversation } from '@/features/ai-chat/types/chat.types';

/**
 * Falls back to a stable positional label ("My chat #N") when a conversation
 * has no user-assigned name, so history rows and the history search box agree
 * on what a conversation is called.
 */
export function getConversationLabel(conversation: Conversation, index: number): string {
  return conversation.name || `My chat #${index + 1}`;
}
